import React, { useState } from "react";
import { C } from "../theme";
import { stars, fmtD, Tag, Btn, Inp } from "../shared";
import { PLANS } from "../data";

export const MarketplacePage = ({ prestataires }) => {
  const [cat, setCat] = useState("Tous");
  const [selected, setSelected] = useState(null);
  const [contact, setContact] = useState({ nom:"", email:"", phone:"", message:"" });
  const [sent, setSent] = useState("");
  const CATS = ["Tous","Nettoyage","Ascenseurs","Plomberie","Sécurité","Électricité","Peinture","Jardinage"];
  const list = cat === "Tous" ? prestataires : prestataires.filter(p => p.cat === cat);

  return (
    <div>
      <div style={{marginBottom:22}}>
        <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Marketplace Prestataires</h2>
        <p style={{color:C.muted,fontSize:13}}>Trouvez des prestataires certifiés pour vos résidences</p>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:20,flexWrap:"wrap"}}>
        {CATS.map(c => (
          <button key={c} className="btn" onClick={() => setCat(c)}
            style={{padding:"7px 15px",borderRadius:20,fontSize:12,fontWeight:600,
              background:cat===c?C.teal:"#fff",color:cat===c?"#fff":C.muted}}>
            {c}
          </button>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
        {list.map((p, i) => {
          const plan = PLANS[p.plan] || PLANS.decouverte;
          const isBusiness = p.plan === "business";
          return (
          <div key={p.id} className="fu ch" style={{animationDelay:`${i*50}ms`,background:C.card,borderRadius:16,padding:20,
            boxShadow:isBusiness?"0 4px 24px rgba(245,158,11,.18)":"0 2px 14px rgba(11,19,51,.06)",
            cursor:"pointer",border:isBusiness?`1.5px solid ${C.gold}44`:"1.5px solid transparent"}}
            onClick={() => setSelected(p)}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
              <div style={{width:44,height:44,borderRadius:12,background:C.tealL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>
                {{"Nettoyage":"🧹","Ascenseurs":"🛗","Plomberie":"🔧","Sécurité":"🔒","Électricité":"⚡","Peinture":"🎨","Jardinage":"🌿"}[p.cat] || "🔧"}
              </div>
              <div style={{display:"flex",gap:5,flexDirection:"column",alignItems:"flex-end"}}>
                {p.certifié && <span style={{background:"#d1fae5",color:"#065f46",fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:20}}>✓ Certifié</span>}
                <span className="plan-badge" style={{background:plan.bg,color:plan.color}}>{plan.icon} {plan.label}</span>
              </div>
            </div>
            {isBusiness && (
              <div style={{background:`linear-gradient(90deg,${C.gold}22,transparent)`,borderRadius:8,padding:"5px 9px",marginBottom:10,display:"flex",alignItems:"center",gap:5}}>
                <span style={{fontSize:11}}>👑</span>
                <span style={{fontSize:11,fontWeight:700,color:C.gold}}>Partenaire Vérifié · Top Listing</span>
              </div>
            )}
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:3}}>{p.nom}</h4>
            <p style={{fontSize:12,color:C.muted,marginBottom:8}}>{p.cat} · {p.ville}</p>
            <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:10}}>
              {stars(p.note)}
              <span style={{fontSize:13,fontWeight:700,color:C.text}}>{p.note}</span>
              <span style={{fontSize:11,color:C.muted}}>({p.avis})</span>
            </div>
            <p style={{fontSize:12,color:C.muted,lineHeight:1.5,marginBottom:12}}>{p.desc.slice(0,80)}…</p>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:12,fontWeight:600,color:C.teal}}>{p.tarif}</span>
              <Btn small>Contacter</Btn>
            </div>
          </div>
          );
        })}
      </div>
      {selected && (
        <div className="ov" onClick={() => setSelected(null)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:18}}>
              <div style={{width:52,height:52,borderRadius:14,background:C.tealL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26}}>🔧</div>
              <div>
                <h3 style={{fontSize:18,fontWeight:700,color:C.text}}>{selected.nom}</h3>
                <p style={{fontSize:13,color:C.muted}}>{selected.cat} · {selected.ville}</p>
              </div>
            </div>
            <p style={{fontSize:14,color:C.text,lineHeight:1.6,marginBottom:16}}>{selected.desc}</p>
            {[["📞",selected.tel],["📧",selected.email],["💰",selected.tarif]].map(([ic,v]) => (
              <div key={ic} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderBottom:`1px solid ${C.border}`}}>
                <span style={{fontSize:16}}>{ic}</span>
                <p style={{fontSize:14,color:C.text,fontWeight:600}}>{v}</p>
              </div>
            ))}
            <div style={{marginTop:18,paddingTop:16,borderTop:`1px solid ${C.border}`}}>
              <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:12}}>Contacter la plateforme pour ce prestataire</h4>
              <Inp label="Votre nom" value={contact.nom} onChange={v => setContact(p => ({...p, nom:v}))} />
              <Inp label="Email" type="email" value={contact.email} onChange={v => setContact(p => ({...p, email:v}))} />
              <Inp label="Téléphone" value={contact.phone} onChange={v => setContact(p => ({...p, phone:v}))} />
              <div style={{marginBottom:14}}>
                <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>Besoin</label>
                <textarea className="inp" rows={4} value={contact.message} onChange={e => setContact(p => ({...p, message:e.target.value}))}
                  style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text,resize:"vertical"}}
                  placeholder={`Décrivez votre besoin pour ${selected.nom}...`} />
              </div>
              {sent && <div style={{background:"#d1fae5",borderRadius:10,padding:"9px 12px",color:"#065f46",fontSize:13,fontWeight:600,marginBottom:12}}>{sent}</div>}
              <div style={{display:"flex",gap:10}}>
                <Btn onClick={() => {
                  if (!contact.nom || !contact.email || !contact.message) return;
                  setSent(`Demande envoyee a la plateforme pour ${selected.nom}.`);
                  setContact({ nom:"", email:"", phone:"", message:"" });
                }} style={{flex:1}}>📋 Envoyer la demande</Btn>
                <Btn onClick={() => setSelected(null)} outline style={{flex:1}}>Fermer</Btn>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — RAPPORTS
══════════════════════════════════════ */
/* ══════════════════════════════════════
   SYNDIC — MAINTENANCE
══════════════════════════════════════ */
